/**
 * 学习日历
 */
import $calendar from '@/api/modules/study-calendar/calendar'
import { AsyncRequest } from '@/utils/request'

const state = {
  list: {
    learnCalendarMonth: [] // 学习日历月份
  },
  item: {},
  obj: {}
}

const getters = {
  calendarList: state => state.list,
  calendarItem: state => state.item,
  shareObj: state => state.obj
}

const mutations = {
  setList: (state, list) => {
    state.list = list
  },
  setItem: (state, item) => {
    state.item = item || {}
  },
  setShareInfo: (state, info) => {
    state.obj = info || {}
  }
}

const actions = {
  // 获取列表
  overview({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $calendar.overview(payload),
      resolve: (list) => commit('setList', list)
    })
  },
  // 获取列表
  rangeview({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $calendar.rangeview(payload),
      resolve: (item) => commit('setItem', item)
    })
  },
  // 获取分享信息
  shareInfo({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $calendar.shareInfo(payload),
      resolve: (info) => commit('setShareInfo', info)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
